/**
 * Silberfluss API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.10
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FullDataViewFields { 
    cache_updated_at?: string;
    can_edit?: boolean;
    created_at?: string;
    created_by?: string;
    folder_id?: string | null;
    id?: string;
    override_updated_at?: string;
    updated_at?: string;
}

